import React from 'react';
import { Row, Col, Card, Skeleton } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import StackedAreaChart from '../../components/StackedAreaChart';
import ModelLatencyChart from '../../components/ModelLatency';
import { useDashboard } from './DashboardContext';
import DashboardStatCard from './DashboardStatCard';
import RecentActivityCard from './RecentActivityCard';
import { formatUptime, formatSince } from './dashboardUtils';

const { Text } = Typography;

export default function DashboardReliability() {
  const {
    isAdmin,
    statistics,
    loading,
    failuresChart,
    modelLatencyData,
    latencyChartEmptyState,
    errorRate,
  } = useDashboard();

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col xs={24} sm={12} md={8}>
          <DashboardStatCard title="Error rate" loading={loading.requests}>
            <div className="stat-value">
              {errorRate != null ? `${errorRate.toFixed(1)}%` : '—'}
            </div>
          </DashboardStatCard>
        </Col>
        {isAdmin && (
          <Col xs={24} sm={12} md={8}>
            <DashboardStatCard title="Platform uptime" loading={loading.statistics}>
              <div className="stat-value">{formatUptime(statistics?.availability?.uptime_seconds)}</div>
              <div className="dashboard-stat__meta">
                <CheckCircleOutlined style={{ color: 'var(--color-success)', marginRight: 4 }} />
                <Text>Since {formatSince(statistics?.availability?.since)}</Text>
              </div>
            </DashboardStatCard>
          </Col>
        )}
      </Row>

      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col xs={24} lg={12}>
          <Card className="modern-card" title={<span className="card-title">Failures over time</span>}>
            {loading.requests ? (
              <Skeleton active paragraph={{ rows: 8 }} />
            ) : (
              <StackedAreaChart
                height={300}
                data={failuresChart.data}
                emptyState={failuresChart.emptyState}
                flatLineKey="failed"
                totalLabel="Failures"
              />
            )}
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card className="modern-card" title={<span className="card-title">Model latency</span>}>
            {loading.modelLatency ? (
              <Skeleton active paragraph={{ rows: 10 }} />
            ) : (
              <ModelLatencyChart
                height={300}
                data={modelLatencyData}
                emptyState={latencyChartEmptyState}
              />
            )}
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <RecentActivityCard failuresOnly drillToReliability />
        </Col>
      </Row>
    </>
  );
}
